import { GlobalMenu } from '@components';
import { AssetContext } from '@pages/Asset/Asset.query';
import { useContext } from 'react';
import { Container } from './PinnedDataMenu.styles';

const PinnedDataMenu = () => {
  const { unpinPinnedData, reOrderPinnedData, restorePinnedData } =
    useContext(AssetContext);

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        itemList={[
          {
            label: 'Re-Order',
            iconName: 'drag-handle-vertical',
            onClick: () => {
              if (reOrderPinnedData.get()) {
                reOrderPinnedData.set(false);
              } else {
                reOrderPinnedData.set(true);
                unpinPinnedData.set(false);
              }
            },
          },
          {
            label: 'Unpin',
            iconName: 'pin',
            onClick: () => {
              if (unpinPinnedData.get()) {
                unpinPinnedData.set(false);
              } else {
                unpinPinnedData.set(true);
                reOrderPinnedData.set(false);
              }
            },
          },
          {
            label: 'Restore Defaults',
            iconName: 'reset',
            onClick: () => {
              restorePinnedData.set(true);
              unpinPinnedData.set(false);
              reOrderPinnedData.set(false);
            },
          },
        ]}
      />
    </Container>
  );
};

export { PinnedDataMenu };
